<template>
  <div id="home" class="home">
    <section id="header" class="py-5">
      <h1 class="text-center">Plateforme de<br />délibération en ligne</h1>
    </section>

    <!-- Apprendre en faisant -->
    <section id="apprendre" class="container">
      <h3 class="mb-4">Apprendre en faisant</h3>
      <p class="mb-4">
        Dlibr est un environnement numérique qui permet d’examiner les différents aspects d’une proposition tout en favorisant des attitudes respectueuses ainsi que des pratiques efficaces et démocratiques.
      </p>
      <p class="mb-4">
        L’interface conviviale offre de structurer la discussion autour d’une proposition initiale et de trois marqueurs de relations: <em>parce que</em>, <em>par contre</em> et <em>donc</em>.
      </p>
      <p class="mb-4">
        <img class="img-fluid" src="@/assets/img/accueil_publier-commentaire.png" />
      </p>
      <p class="mb-5 text-center">
        Fonction <strong>Écrire un commentaire</strong>
      </p>
      <p class="mb-4">
        Dlibr génère une dynamique de participation qui encourage les apprenantes et les apprenants à rédiger plusieurs arguments et à lire ceux des autres afin de construire une discussion raisonnée et animée.
      </p>
      <p class="mb-4">
        La plateforme propose différentes visualisations de la délibération et plusieurs modes d’interaction enseignant-étudiant, et elle peut servir autant pour un exercice formatif que pour un exercice sommatif.
      </p>
      <p>
        Consultez la section <router-link :to="{ name: 'about' }">À propos</router-link> pour en savoir plus sur l’approche pédagogique.
      </p>
    </section>

    <!-- Découvrez -->
    <section id="decrouvrez" class="container">
      <div class="row">
        <div class="col-12">
          <h3>Découvrez toutes les fonctionnalités grâce aux guides</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12 pr-md-5 pt-2">
          <a class="pdf-link" href="https://ccdmd.qc.ca/wp-content/uploads/2024/01/dlibr_guide_enseignant_0.pdf" target="_blank">
            <img class="img-fluid my-4" src="@/assets/img/guide_enseignant-vignette.png" />
            <p class="text-center mb-2">Guide de l'enseignant</p>
          </a>
          <p class="text-center text-muted"><small>18 pages<span class="mx-2">&#9642;</span>2,6 mo</small></p>
        </div>
        <div class="col-md-6 col-sm-12 pl-md-5 pt-2">
          <a class="pdf-link" href="https://ccdmd.qc.ca/wp-content/uploads/2024/01/dlibr_guide_etudiant_0.pdf" target="_blank">
            <img class="img-fluid my-4" src="@/assets/img/guide_etudiant-vignette.png" />
            <p class="text-center mb-2">Guide de l'étudiant</p>
          </a>
          <p class="text-center text-muted"><small>11 pages<span class="mx-2">&#9642;</span>1,2 mo</small></p>
        </div>
      </div>
    </section>

    <!-- call to action -->
    <b-jumbotron bg-variant="light" class="mb-5">
      <template v-slot:header>
        <div class="container">
          <h1>Vous êtes une ou un enseignant?</h1>
        </div>
      </template>

      <template v-slot:lead>
        <div class="container">
          Faites la demande de votre compte
        </div>
      </template>

      <div class="container">
        <hr class="my-4" />

        <b-row>
          <b-col sm="12" md="4">
            <b-btn
              :to="{ name: 'teachers.register' }"
              block
              class="text-light"
              pill
              variant="info"
              >Demander un compte</b-btn
            >
          </b-col>
        </b-row>
      </div>
    </b-jumbotron>
  </div>
</template>
<script>
/**
 * @file       Home component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

/**
 * Export component.
 * 
 * @type  {Object}
 */
export default {
  name: "Home"
};
</script>
